"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoPanel = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _atoms = require("../../atoms");

require("./InfoPanel.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var InfoPanel = function InfoPanel(_ref) {
  var open = _ref.open,
      children = _ref.children,
      onInfoPanelShadeClick = _ref.onInfoPanelShadeClick;
  var el = document.getElementById("modal-root");
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, open && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "InfoPanel-shade",
    onClick: onInfoPanelShadeClick
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "InfoPanel"
  }, children))), el);
};

exports.InfoPanel = InfoPanel;